(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instagram"] && !Shopify.designMode) return;
  try {
    
if ((document.body.classList.contains('template-index') && document.querySelector('.ax-section.instagram') !== null)) {
  let htmlPostList = ''
  let htmlTarget = document.querySelector('.ax-section.instagram .instagram-container');

  fetch(`https://d3ejra0xbg20rg.cloudfront.net/instagram/media?shop=${Shopify.shop}&resource=default`)
    .then((response) => {
      response.json()
        .then((instagramElements) => {
          for (let i = 0; i < instagramElements.length; i++) {
            if (i >= 4) break
            let htmlBlock =
                `<div class="ax-square-block swiper-slide">
                            <a class="square" target="_blank" href="${instagramElements[i].permalink}">
                                <img class="ax-lazyload-instagram" data-src="${instagramElements[i].media_url}" alt="" width="300">
                            </a>
                         </div>`
              htmlPostList += htmlBlock
          }
          htmlTarget.innerHTML = htmlPostList;
          observe();
        }).catch(error => {
        console.error(error)
        document.querySelector('.ax-section.instagram').style.display = "none"
      });
    });

  function observe() {
    let options = {
      threshold: .1
    }
    let observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        let srcImg = entry.target
        if (entry.isIntersecting) {
          let img = document.querySelectorAll('.shopify-section-lazy .ax-lazyload-instagram');
          img.forEach(el => {
            el.src = el.getAttribute('data-src');
            el.classList.add('load');
          })
          observer.unobserve(srcImg);
        }
      })
    }, {
      options
    })

    let target = document.querySelectorAll('.shopify-section-lazy');
    target.forEach(function (el) {
      observer.observe(el);
    })
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

      theme.peekCarousel.init(
        productRecommendationsSection,
        $('.js-related-product-carousel', productRecommendationsSection),
        '.productRecommendations',
        function() {
          return $(window).width() < 992
        },
        false
      );
    }
  };
  request.send();
};
// Reload the section in the editor when a setting changes
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
document.addEventListener("shopify:section:unload", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    theme.peekCarousel.destroy(
      $('.product-recommendations', event.target),
      $('.js-related-product-carousel', event.target),
      '.productRecommendations'
    );
  }
});
// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();
})();
